import { render, staticRenderFns } from "./SocialSetting.vue?vue&type=template&id=bdd7efd6&"
import script from "./SocialSetting.vue?vue&type=script&lang=js&"
export * from "./SocialSetting.vue?vue&type=script&lang=js&"
import style0 from "./SocialSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports